// extracted by mini-css-extract-plugin
module.exports = {"card":"style__card__7spIH"};